import { Injectable } from '@angular/core';
import { QueryOperation } from '@nibras/core/common';
import { firstValueFrom } from 'rxjs';
import { HttpService } from './http.service';
import { dcAttributeDataSource } from './model/dc-attribute-data-source.model';

@Injectable()
export class DatasourceService {
  private attributeDataSourceCache: Map<string, dcAttributeDataSource> = new Map();

  constructor(private httpService: HttpService) {}

  async getAttributeDataSource(attributeId: number, queryOperation: QueryOperation = 1) {
    const cacheKey = attributeId + '-' + queryOperation;
    let dataSource: dcAttributeDataSource = null;
    if (this.attributeDataSourceCache.has(cacheKey)) {
      dataSource = this.attributeDataSourceCache.get(cacheKey);
    } else {
      dataSource = await firstValueFrom(
        this.httpService.get<dcAttributeDataSource>(
          `App/GetAttributeDataSource?attributeid=${attributeId}&QueryOperation=${QueryOperation}`
        )
      ).catch(e => null);
      if (dataSource && Object.keys(dataSource).length) {
        this.attributeDataSourceCache.set(cacheKey, dataSource);
      } else {
        return Promise.reject(null);
      }
    }
    return dataSource;
  }
}
